import { formatDateWithoutTime } from '../../../../../helpers/DateFormatter';
import i18n from '../../../../../config/i18n/i18n';

export const makeInitialState = (
  name,
  lastname,
  dni,
  birthDate,
  phone,
  email,
) => {
  const initialState = {
    firstName: {
      value: name,
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Nombre',
      success: false,
    },
    lastName: {
      value: lastname,
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Apellido',
      success: false,
    },
    logonId: {
      value: dni,
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: i18n.t('profile.officialDocument'),
      success: false,
    },
    dateOfBirth: {
      value: formatDateWithoutTime(birthDate),
      error: false,
      message: '',
      helper: 'dd/mm/aaaa',
      inputAdornment: '',
      label: 'Fecha de nacimiento',
      success: false,
    },
    phone1: {
      value: phone,
      error: false,
      message: '',
      helper: 'Ingrese 9 dígitos',
      inputAdornment: i18n.t('profile.phoneAdornment'),
      label: 'Teléfono',
      success: false,
    },
    email1: {
      value: email,
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Email',
      success: false,
    },
  };
  return initialState;
};

export const inputsInState = [
  'firstName',
  'lastName',
  'logonId',
  'dateOfBirth',
  'phone1',
  'email1',
];
